import { Handle, Position } from 'reactflow';
import IfThen from '../IfThen';

const handleStyle = { left: 10 };

function TextUpdaterNode(props) {
    
  const renderDefault = () => {

    return (
      <>
        <Handle type="target" position={Position.Left} className='handle-connector' />
        { props.data.default.text && <p className='nowrap-lines-2'>{props.data.default.text.es}</p>}
        
        { props.data.default.image && <img src={props.data.default.image.es.link} className='img-fluid' />}
        <Handle type="source" position={Position.Right} className='handle-connector' />
      </>
    )
  }

  const renderHTTP = () => {
    return (
      <>
        <Handle type="target" position={Position.Left} className='handle-connector' />
        <div className='chatbot-node-http'>
          <h6>URL DEV</h6>
          <p className='m-b-8 nowrap-lines-1'>{props.data.http.url_dev}</p>

          <h6>URL PRODUCCIÓN</h6>
          <p className='m-b-8 nowrap-lines-1'>{props.data.http.url_prod}</p>

          {/* <h6 className='m-b-4'>Payload</h6>
          <ul className='tags m-b-8'>
            {
              props.data.http.payload.map( (p, i) => <li key={i}><span>{p}</span></li> )
            }
          </ul> */}
          
          <h6 className='m-b-4'>Respuestas</h6>
          <ul className='chatbot-node-outputs'>
            {
              props.data.http.responses.map( (r, i) => <li key={i} className='nowrap-lines-1 position-relative'><span>{r}</span><Handle type="source" position={Position.Right} id={r} className='handle-connector internal' /></li> )
            }
          </ul>
        </div>
        
      </>
    )
  }
  
  const renderInteractive = () => {
    const { data: { interactive: { type, text, list, buttons} } } = props

    let interactive = type === 'LIST' ? list: buttons;

    const _renderInteractive = () => (
        <>
          <Handle type="target" position={Position.Left} className='handle-connector' />
          <div className='chatbot-node-http'>
            { interactive.header &&  <h6 className='nowrap-lines-1 m-b-8'>{interactive.header.es}</h6> }
  
            <p className='nowrap-lines-2 m-b-8'>{interactive.body.es}</p>
  
            { interactive.footer && <p className='nowrap-lines-1 m-b-8'><i>{interactive.footer.es}</i></p> }
  
            <h6 className='m-b-4'>Opciones</h6>
            <ul className='chatbot-node-outputs'>
              {
                interactive.action.sections.rows.map((row, index) => <li key={index} className='nowrap-lines-1 position-relative'><span>{row.text? row.text.es: row.es}</span><Handle type="source" position={Position.Right} id={row.text? row.text.es: row.es} className='handle-connector internal' /></li> )
              }
            </ul>
          </div>
        </>
    )
    
    const _renderText = () => (
      <>
        <Handle type="target" position={Position.Left} className='handle-connector' />
        <div className='chatbot-node-http'>
          <p className='nowrap-lines-2 m-b-8'>{text.es}</p>          
        </div>
        <Handle type="source" position={Position.Right} className='handle-connector' />
      </>
    )

    return type === 'TEXT' ? _renderText(): _renderInteractive();
  }

  const renderClose = () => {
    return (
      <>
        <Handle type="target" position={Position.Left} className='handle-connector' />
        
        <p className='nowrap-lines-2 m-b-8'>{props.data.close.message.es}</p>
        <h6 className='m-b-4'>Categoría de cierre</h6>
        <ul className='tags '>
          <li><span>{props.data.close.category}</span></li>
        </ul>
      </>
    )
  }

  const renderRedirect = () => {
    return (
      <>
        <Handle type="target" position={Position.Left} className='handle-connector' />
        <p className='nowrap-lines-2 m-b-8'>{props.data.redirect_agent.message.es}</p>
        <h6 className='m-b-4'>Agentes</h6>
        <ul className='tags '>
          {
            props.data.redirect_agent.agents.map( (p, i) => <li key={i}><span>{p}</span></li> )
          }
        </ul>
      </>
    )
  }

  const renderBody = () => {
    switch (props.data.type) {
      case 'DEFAULT':
        return renderDefault();
      
      case 'INTERACTIVE':
        return renderInteractive();
    
      case 'HTTP':
        return renderHTTP();

      case 'REDIRECT_AGENT':
        return renderRedirect();

      case 'CLOSE':
        return renderClose();
      
    }
  }

  const renderType = () => {
    switch (props.data.type) {
      case 'DEFAULT':
        return (<><i className="bi-justify-left "></i> Predeterminado</>);
    
      case 'HTTP':
        return (<><i className="bi-hdd-network "></i> Validación HTTP</>);
    
      case 'CLOSE':
        return (<><i className="bi-slash-circle "></i> Finalizar flujo</>);

      case 'REDIRECT_AGENT':
        return (<><i className="bi-people "></i> Redireccionar agente</>);

      case 'INTERACTIVE':
        const { data: { interactive } } = props
        return (<><i className="bi-chat-dots "></i> Interactivo { interactive?.type  && <>({`${interactive?.type ==='TEXT' ? 'Texto':( interactive?.type==='LIST'? 'Lista': 'Respuestas rápidas' )}`})</> }</>);

      default:
        return props.data.type;
    }
  }
  

  return (
   <div className='chatbot-node-container'>
      <div className='chatbot-node-header'>
        <h6 className='nowrap-lines-1'>
          <IfThen condition={props.data.name}>
            {props.data.name}
          </IfThen>
        </h6>
        <p className='nowrap-lines-1'>{renderType()}</p>
      </div>
      <div className='chatbot-node-body'>

        { props.data._id && renderBody() }

        { !props.data._id && (
          <div className="text-center">
              <div className="alert alert-soft-danger m-0">
                  <p>Nodo sin configuración</p>
              </div>
          </div>
        )}

      </div>
   </div>
  );
}

export default TextUpdaterNode;
